import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpLaravelHeaders } from '@app/_interceptors/url.interceptor';
import { ResponseObject } from '@app/_shared/interfaces';
import { PostingCredits } from '@app/_shared/interfaces/http/posting-credits';

@Injectable({
  providedIn: 'root',
})
export class PostingCreditsService {
  private _http = inject(HttpClient);

  private headers = new HttpLaravelHeaders();

  private endpoint = '/api/v1/user/posting-credits';

  index(params?: HttpParams) {
    return this._http.get<ResponseObject<PostingCredits>>(this.endpoint, {
      headers: this.headers,
      params,
    });
  }
}
